import { useLocation } from "react-router";
import { isBinderType } from "models/BinderItem";

export const useBinderType = () => {
  const typeParam = new URLSearchParams(useLocation().search).get("type");
  return isBinderType(typeParam) ? typeParam : null;
};
